import ArticleInfo from '@/components/BlogComponents/shared/ArticleInfo/ArticleInfo';
import BlogTag from '@/components/BlogComponents/shared/BlogTag/BlogTag';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import Link from '@/components/Link/Link';
import type { FrontifyImageContent } from '@/contentful';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './BlogCard.styles';

export interface BlogCardProps {
  image?: FrontifyImageContent[];
  title: string;
  url?: string;
  categoryPath?: string;
  date: string;
  readTime: number;
  category?: string | null;
}

export default function BlogCard({
  image,
  title,
  url,
  date,
  readTime,
  category,
  categoryPath,
}: BlogCardProps): React.JSX.Element {
  const { classes } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div className={classes.blogCard} data-testid='blog-card'>
      <Link href={url}>
        {image?.[0] && (
          <div className={classes.image}>
            <ResponsiveImage
              src={image[0]}
              alt={image[0].title}
              sizes={{ xs: 600 }}
            />
          </div>
        )}
      </Link>
      <div className={classes.textContainer}>
        <Link className={classes.title} href={url} title={title}>
          <h3 className={globalClasses.h3}>{title}</h3>
        </Link>
        <div className={classes.metadata}>
          <ArticleInfo
            publicationDate={date}
            readingTime={readTime}
            textColor='black'
          />
        </div>
      </div>
      {category && categoryPath && (
        <BlogTag
          category={category}
          path={categoryPath}
          className={classes.blogTag}
        />
      )}
    </div>
  );
}
